import { useEffect } from "react";
import { useLocation } from "react-router-dom";

import { ReactComponent as LogoSVG } from "@/assets/img/logo/redirect-flow-logo.svg";
import useMetaCookies from "@/hooks/useMetaCookies";

const FBP_URL_PARAM = "af_sub2";
const FBC_URL_PARAM = "af_sub1";

const ChallengesRedirect = () => {
    const location = useLocation();
    const { fbp: fbpCookie, fbc: fbcCookie } = useMetaCookies();

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        if (fbpCookie) {
            params.set(FBP_URL_PARAM, fbpCookie);
        }
        if (fbcCookie) {
            params.set(FBC_URL_PARAM, fbcCookie);
        }
        const newUrl = `https://zingcoach.onelink.me/gsGu/gi5fu0c7?${params.toString()}`;
        window.location.assign(newUrl);
    }, [fbcCookie, fbpCookie, location.search]);
    return (
        <div className="flex justify-center pt-[140px]">
            <LogoSVG />
        </div>
    );
};

export default ChallengesRedirect;
